import { Controller } from "stimulus"
import useColorScheme from "use-color-scheme"

export default class extends Controller {
  static values = { config: Object }

  connect() {
    useColorScheme(this)
    this.chart = new window.Chart(this.element.getContext("2d"), this.config)
  }

  disconnect() {
    this.chart?.destroy()
  }

  configValuechanged() {
    this.chart.data.labels = this.configValue.labels
    this.chart.data.datasets = this.datasetsConfig
    this.chart.update()
  }

  colorSchemeChanged() {
    if (!this.chart) { return }

    this.chart.data.datasets = this.datasetsConfig
    Object.assign(this.chart.config.options, this.options)
    this.chart.update('none')
  }

  get datasetsConfig() {
    return this.configValue.datasets.map(ds => {
      let bg = ds.backgroundColor
      if (bg) {
        const v = Array.isArray(bg) ? bg : [ bg ]
        bg = v.map(c => this.getCssVal(c))
      }

      let b = ds.borderColor
      if (b) {
        const v = Array.isArray(b) ? b : [ b ]
        b = v.map(c => this.getCssVal(c))
      }

      return { ...ds, backgroundColor: bg, borderColor: b }
    })
  }

  get config() {
    return {
      type: this.configValue.type,
      data: {
        labels: this.configValue.labels,
        datasets: this.datasetsConfig
      },
      options: {
        ...this.options,
        maintainAspectRatio: false,
        responsive: true,
        hover: { mode: null },
        animation: { animateScale: false, animateRotate: false },
        plugins: this.plugins
      }
    }
  }

  get options() {
    if (this.configValue.type == "doughnut") {
      return {
        interaction: {
          mode: "dataset"
        }
      }
    }

    return {
      indexAxis: 'y',
      scales: {
        x: {
          beginAtZero: true,
          ticks: {
            stepSize: 1
          }
        },
        y: {
          stacked: true
        }
      },
      interaction: {
        mode: "index"
      }
    }
  }

  get plugins() {
    if (this.configValue.type == "doughnut") {
      return {
        legend: {
          position: 'bottom',
          labels: {
            color: this.getCssVal('--bulma-text')
          },
        },
        tooltip: {
          callbacks: {
            label(context) {
              if (context.raw.tooltipLabel === false) {
                return null
              }
              return context.raw.tooltipLabel
            }
          }
        }
      }
    }

    return {
      legend: {
        position: 'bottom',
      }
    }
  }

  getCssVal(v) {
    return getComputedStyle(this.element).getPropertyValue(v).trim() || v
  }
}
